import { DataConfig } from "@/components/table/useDefaultDataConfig";
import moment from "moment";

const searchFieldConfig = {
  usePrefix: [
    "clusterId",
    "drawingIdAbd",
    "projectId",
    "cityTown",
    "fdtId",
    "projectName",
    "oltId",
    "combineStatus",
    "totalHpRfs",
    "subdistrict.subdistrictName",
    "villageName",
    "subdistrict.city.cityName",
    "subdistrict.city.province.provinceName",
    "postalCode",
    "villageCode",
    "paramType",
    "paramTag",
    "value",
    "value2",
    "active",
    "companyCode",
    "companyName",
    "department",
    "noTelp",
    "email",
    "address",
    "cityName",
    "cityCode",
    "province.provinceName",
    "ftax",
    "fdtAreaHpm.value",
    "fibernodeAreaHpm.value",
    "branchHpm.value",
    "subdistrictName",
    "city.cityName",
    "subdistrictCode",
    "provinceName",
    "provinceCode",
    "categoryBizpass",
    "dwellingType",
    "profileName",
    "rollOutType",
    "latitude",
    "longitude",
  ],
};

function applyPrefix(key: string) {
  if (key == "ftax") {
    key = "ftaxs";
  }
  return searchFieldConfig.usePrefix.includes(key) ? `searchField.${key}` : key;
}

export const handleFilterByColumns = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterBy: { [key: string]: any },
  setDataConfig?: React.Dispatch<React.SetStateAction<DataConfig>>,
  dataConfig?: DataConfig,
) => {
  /**
   * Renames a key in the `filterBy` object from `origin` to `replace`.
   * If the `origin` key exists in `filterBy` or its value is an empty string,
   * it assigns the value of `origin` to `replace` and deletes the `origin` key.
   *
   * @param origin - The original key in the `filterBy` object to be renamed.
   * @param replace - The new key name to replace the original key.
   */
  const renameKeys = (origin: string, replace: string) => {
    if (filterBy[origin] || filterBy[origin] === "") {
      filterBy[replace] = filterBy[origin];
      delete filterBy[origin];
    }
  };
  renameKeysMapping.forEach(([origin, replace]) => renameKeys(origin, replace));

  if (filterBy["createdDate"]) {
    filterBy["startCreatedDate"] = filterBy["createdDate"]["date_start"]
      ? moment(filterBy["createdDate"]["date_start"]).format("YYYY-MM-DD")
      : undefined;
    filterBy["endCreatedDate"] = filterBy["createdDate"]["date_end"]
      ? moment(filterBy["createdDate"]["date_end"]).format("YYYY-MM-DD")
      : undefined;

    delete filterBy["createdDate"];
  }

  if (filterBy["updatedDate"]) {
    filterBy["startUpdatedDate"] = filterBy["updatedDate"]["date_start"]
      ? moment(filterBy["updatedDate"]["date_start"]).format("YYYY-MM-DD")
      : undefined;
    filterBy["endUpdatedDate"] = filterBy["updatedDate"]["date_end"]
      ? moment(filterBy["updatedDate"]["date_end"]).format("YYYY-MM-DD")
      : undefined;

    delete filterBy["updatedDate"];
  }

  if (filterBy["monthTargetString"]) {
    filterBy["monthTargets"] = filterBy["monthTargetString"];
    delete filterBy["monthTargetString"];
  }

  if (filterBy["yearTarget"]) {
    filterBy["yearTargets"] = filterBy["yearTarget"]["current_year"];
    delete filterBy["yearTarget"];
  }

  const prefixedFilterBy = Object.fromEntries(
    Object.entries(filterBy).map(([key, value]) => [applyPrefix(key), value]),
  );

  if (setDataConfig) {
    setDataConfig({
      ...dataConfig,
      ...prefixedFilterBy,
      page: "0",
    });
  }
};

const renameKeysMapping = [
  ["picLinknet", "picLinknet.username"],
  ["picVendor", "picVendor.username"],
  ["status", "statusRfsSubmissions"],
];
